import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../../models/report.model';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IconsModule } from '../../../../shared/design-system/icons/icons.module';
import { PInputComponent } from '../../../../shared/design-system/atoms/p-input/p-input.component';
import { PButtonComponent } from '../../../../shared/design-system/atoms/p-button/p-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-les-plus-edit-mode',
  templateUrl: './les-plus-edit-mode.component.html',
  styleUrls: ['./les-plus-edit-mode.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PButtonComponent,
    PInputComponent,
    IconsModule,
    ReactiveFormsModule,
  ],
})
export class LesPlusEditModeComponent implements OnChanges {
  @Input() perks!: Report.Perk;

  @Output() perksChanged = new EventEmitter<Report.Perk>();

  newPerks!: Report.Perk;

  perksForm = new FormGroup({
    perk: new FormControl(''),
  });

  get isAddPerkDisabled(): boolean {
    return (
      this.newPerks.items.length >= 12 ||
      this.perksForm.controls.perk.value === ''
    );
  }

  get addPerkTitle(): string {
    if (this.newPerks.items.length >= 12) {
      return 'Vous avez atteint le nombre maximum des plus';
    }

    if (this.perksForm.controls.perk.value === '') {
      return 'Veuillez saisir un plus';
    }

    return 'Ajouter';
  }

  get isMaxPerksReached(): boolean {
    return this.newPerks.items.length >= 12;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentPerks = changes['perks'].currentValue;
    if (currentPerks) {
      this.newPerks = currentPerks;
    }
  }

  addPerk(): void {
    const newPerk = this.perksForm.controls.perk.value;
    if (newPerk && newPerk.length > 0) {
      this.newPerks.items.push(newPerk);

      this.perksChanged.emit(this.newPerks);
      this.perksForm.controls.perk.setValue('');
    }
  }

  deletePerk(perk: string): void {
    this.newPerks.items = this.newPerks.items.filter((p) => p !== perk);
    this.perksChanged.emit(this.newPerks);
  }
}
